import { apiDelete, apiGet, apiPatch, apiPost, apiPut, apiUrl } from "../../shared/api";

/** Una fattura estera (servizio o marketplace) da cui nasce un'autofattura.
 *  L'importo e' una STRINGA: arriva da Decimal, un float perderebbe esattezza. */
export type FatturaEstera = {
  id: number;
  fornitore: string;
  fornitore_nome: string;
  /** ``null``: il fornitore fattura da piu' paesi, si guarda il PDF. */
  paese: string | null;
  portale: string | null;
  origine: "mail" | "manuale" | "portale";
  casella: string;
  mittente: string;
  oggetto: string;
  mittente_verificato: boolean;
  /** Nota di credito del fornitore: l'integrazione la fa Annalisa a mano. */
  nota_di_credito: boolean;
  numero: string | null;
  data_documento: string;
  importo: string | null;
  /** Letto dal PDF: serve a cercare la AUT in Eureka, non e' un dato certo. */
  importo_letto: string | null;
  valuta: string | null;
  /** L'autofattura trovata in Eureka (documento AUT), se la spunta e' sua. */
  eureka_aut: { numero: number; data: string | null } | null;
  nota: string | null;
  autofattura_il: string | null;
  autofattura_da: string | null;
  caricata_da: string | null;
  /** Tasto «Crea in Eureka»: ``motivo`` dice perche' e' spento (null = si puo'). */
  aut_crea: { motivo: string | null; errore: string | null };
  pdf: Array<{ id: number; nome: string }>;
};

export type FornitoreEstero = {
  chiave: string;
  nome: string;
  paese: string | null;
  portale: string | null;
};

export type ElencoFattureEstere = {
  fatture: FatturaEstera[];
  fornitori: FornitoreEstero[];
  caselle: { lette: string[]; saltate: string[] };
  ultimo_giro: {
    quando: string;
    ok: boolean;
    errore: string | null;
    eureka: { aut_nuove?: number; abbinate?: number; errore?: string } | null;
  } | null;
};

export type Correzione = {
  numero?: string;
  data_documento?: string;
  importo?: string;
  valuta?: string;
  nota?: string;
};

const ROTTA = "/api/invoicing/fatture-estere";

export function fetchFattureEstere(signal?: AbortSignal): Promise<ElencoFattureEstere> {
  return apiGet(ROTTA, signal ? { signal } : undefined);
}

export function rileggiPosta(): Promise<{ accodato: boolean }> {
  return apiPost(`${ROTTA}/rileggi`);
}

export function segnaAutofattura(id: number, fatta: boolean): Promise<{ ok: boolean }> {
  return apiPut(`${ROTTA}/${id}/autofattura`, { fatta });
}

export function correggiFattura(id: number, corpo: Correzione): Promise<{ ok: boolean }> {
  return apiPatch(`${ROTTA}/${id}`, corpo);
}

/** Crea l'autofattura in Eureka copiando l'ultima di Annalisa per il fornitore. */
export function creaAut(
  id: number,
): Promise<{ numero: number; data: string; gia_esistente: boolean }> {
  return apiPost(`${ROTTA}/${id}/crea-aut`);
}

export function eliminaFattura(id: number): Promise<void> {
  return apiDelete(`${ROTTA}/${id}`);
}

/** ``apiUrl`` (relativo): in DEV passa dal proxy Vite, che porta il cookie. */
export function urlPdf(pdfId: number): string {
  return apiUrl(`${ROTTA}/pdf/${pdfId}`);
}

/** Un portale col robot delle fatture: la password non torna mai indietro. */
export type AccessoPortale = {
  portale: string;
  nome: string;
  configurato: boolean;
  utente: string | null;
  con_codice: boolean;
  aggiornato_il: string | null;
  aggiornato_da: string | null;
};

export function fetchAccessi(signal?: AbortSignal): Promise<AccessoPortale[]> {
  return apiGet(`${ROTTA}/accessi`, signal ? { signal } : undefined);
}

/** ``password`` vuota tiene quella salvata; ``totp`` vuoto toglie il codice. */
export function salvaAccesso(
  portale: string,
  corpo: { utente: string; password?: string; totp?: string },
): Promise<{ ok: boolean }> {
  return apiPut(`${ROTTA}/accessi/${portale}`, corpo);
}
